import React, { useMemo, useEffect, useState, useContext } from 'react';
import { Form, Button, Dimmer } from 'semantic-ui-react';
import { DatePicker, TimePicker } from '../../../components/shared/DatePicker';
import RoomTypesDropDown from '../../../components/shared/RoomTypesDropDown';
import ProductsDropDown from '../../../components/shared/ProductsDropDown';
import WingDropDown from '../../../components/shared/WingDropDown';
import Panel from '../../../components/shared/Panel';
import PropTypes from "prop-types";
import moment from 'moment'
import formatCurrency from 'format-currency'
import { Currencies } from '../../../components/shared/currencies'
import { GetProducts, CalculateTotalAmountCurrentReservation } from '../../../api/services/pms';
import _ from 'lodash'
import LanguageContext from '../../../language';
import { ReservationStatusTypes } from '../../../components/shared/statustypes'
import { GroupReservationContext } from '../context';
import CurrencyInput from '../../../components/shared/CurrencyInput';
import { onWarning, onError } from '../../../components/shared/messages';
import NumericInput from '../../../components/shared/NumericInput';
import { useLoader } from '../../../components/shared/utils';

const BlockDetailsPanel = ({ reservation, reservationSavedState, HotelID, onSave, onCancel, isDirtyChange }) => {
    const loader = useLoader()
    const { state } = useContext(GroupReservationContext)
    const reservationGroup = state.ReservationGroup
    const reservations = reservationGroup.ReservationGroupReservations
    const [errors, setErrors] = useState({})
    const [reservationState, setReservationState] = useState(reservation)
    const [isDirtyState, setIsDirtyState] = useState(false)
    let fits = _.filter(reservations, r => r.ParentReservationID === reservation.Id)

    useEffect(() => {
        setReservationState(reservation)
        initBlockPrices(reservation)
        setIsDirtyState(false)
        setErrors({})
    }, [reservation])

    const initBlockPrices = (reservation)=> {
        let nights = (moment(reservation.CheckOutDate).startOf('day').diff(moment(reservation.CheckInDate).startOf('day'), 'days'))
        if (!nights) nights = 1

        setReservationState(prev => {

            if(fits && fits.length > 0){
               
                let fitsTotalafter = _.sumBy(fits, r => r.Reservation.Id !== 0 ? parseFloat(r.Reservation.TotalAmountProductCurrentAfterTax) : 0)
                let totalAfter =  parseFloat(reservation.TotalAmountProductCurrentAfterTax + fitsTotalafter)

                let fitsTotalBefore = _.sumBy(fits, r => r.Reservation.Id !== 0 ? parseFloat(r.Reservation.TotalAmountProductCurrentBeforeTax) : 0)
                let totalBefore =  parseFloat(reservation.TotalAmountProductCurrentBeforeTax + fitsTotalBefore)
        
                prev.TotalAmountProductCurrentBeforeTax = totalBefore
                prev.TotalAmountProductCurrentAfterTax = totalAfter

            }    
            return { ...prev }
        })
    }

    const onBlockFieldChange = (value, name) => {
        setReservationState(prev => {
            switch (name) {
                case 'WingID':
                    prev['RoomTypeId'] = null;
                    break;
                case 'ProductID':
                    prev['ReservationPricingTypeID'] = 1;
                    break;
                default:
                    break;
            }
            prev[name] = value;
            return { ...prev }
        })
        setIsDirtyState(true)
    }

    const onBlockDateFieldChange = (value, name) => {
        setReservationState(prev => {
            switch (name) {
                case 'CheckInDate':
                    if (moment(value).startOf('day').diff(moment(prev.CheckOutDate).startOf('day'), 'days') > 0) {
                        prev['CheckOutDate'] = moment(value).add(1, 'days')
                    }
                    break;
                case 'CheckOutDate':
                    if (moment(value).startOf('day').diff(moment(prev.CheckInDate).startOf('day'), 'days') < 0) {
                        prev['CheckInDate'] = moment(value).add(-1, 'days')
                    }
            }
            prev[name] = value;
            return { ...prev }
        })
        setIsDirtyState(true)
    }

    const onSelectedProduct = product => {
        setReservationState(prev => {
            if (product) {
                let nights = (moment(prev.CheckOutDate).startOf('day').diff(moment(prev.CheckInDate).startOf('day'), 'days'))
                if (!nights) nights = 1
                prev.ProductID = product.Id
                prev.TotalAmountProductCurrentBeforeTax = (product.TotalAmountBeforeTax * prev.Quantity)
                prev.TotalAmountProductCurrentAfterTax = (product.TotalAmountAfterTax * prev.Quantity)
                prev.AveragePricePerNightBeforeTax = ((product.TotalAmountBeforeTax * prev.Quantity) / nights)
                prev.AveragePricePerNightAfterTax = ((product.TotalAmountAfterTax * prev.Quantity) / nights)
                prev.CurrencyId = product.CurrencyId
            }
            else {
                prev.ProductID = null
                prev.TotalAmountProductCurrentBeforeTax = null
                prev.TotalAmountProductCurrentAfterTax = null
                prev.AveragePricePerNightBeforeTax = null
                prev.AveragePricePerNightAfterTax = null
            }
            return { ...prev }
        })
    }

    const onPriceFieldsChange = (val, name) => {
        let value = parseFloat(val)
        let reservation = { ...reservationState }
        let nights = (moment(reservation.CheckOutDate).startOf('day').diff(moment(reservation.CheckInDate).startOf('day'), 'days'))
        if (!nights) nights = 1
        switch (name) {
            case 'AveragePricePerNightBeforeTax':
                reservation.AveragePricePerNightBeforeTax = value
                reservation.OverriddenTotalAmount = value * nights
                reservation.IsOverriddenTotalAmountAfterTax = false
                reservation.OverrideProductPrice = true;
                reservation.ReservationPricingTypeID = 2;
                break;
            case 'AveragePricePerNightAfterTax':
                reservation.AveragePricePerNightAfterTax = value
                reservation.OverriddenTotalAmount = value * nights
                reservation.IsOverriddenTotalAmountAfterTax = true
                reservation.OverrideProductPrice = true;
                reservation.ReservationPricingTypeID = 2;
                break;
            case 'TotalAmountProductCurrentBeforeTax':
                reservation.TotalAmountProductCurrentBeforeTax = value
                reservation.OverriddenTotalAmount = value
                reservation.IsOverriddenTotalAmountAfterTax = false
                reservation.OverrideProductPrice = true;
                reservation.ReservationPricingTypeID = 2;
                break;
            case 'TotalAmountProductCurrentAfterTax':
                reservation.TotalAmountProductCurrentAfterTax = value
                reservation.OverriddenTotalAmount = value
                reservation.IsOverriddenTotalAmountAfterTax = true
                reservation.OverrideProductPrice = true;
                reservation.ReservationPricingTypeID = 2;
                break;
            default:
                break;
        }
        calc({ reservation, name, nights })
    }

    const calc = useMemo(() => _.debounce(async ({
        reservation,
        name,
        nights
    }) => {
        try {
            loader(true);
            const updated = await CalculateTotalAmountCurrentReservation({
                Reservation: reservation,
                IsReCalculateTax: true,
                IncludeCommissionCalculation: reservation.Id ? true : false,
                DigitsPercision: 8
            })
            /*eslint-disable */
            switch (name) {
                case 'AveragePricePerNightBeforeTax':
                    reservation.TotalAmountProductCurrentBeforeTax = (updated.TotalAmountProductCurrentBeforeTax)
                    reservation.TotalAmountProductCurrentAfterTax = (updated.TotalAmountProductCurrentAfterTax)
                    reservation.AveragePricePerNightAfterTax = (updated.TotalAmountProductCurrentAfterTax / nights)
                    break;
                case 'AveragePricePerNightAfterTax':
                    reservation.TotalAmountProductCurrentBeforeTax = (updated.TotalAmountProductCurrentBeforeTax)
                    reservation.TotalAmountProductCurrentAfterTax = (updated.TotalAmountProductCurrentAfterTax)
                    reservation.AveragePricePerNightBeforeTax = (updated.TotalAmountProductCurrentBeforeTax / nights)
                    break;
                case 'TotalAmountProductCurrentBeforeTax':
                    reservation.TotalAmountProductCurrentAfterTax = (updated.TotalAmountProductCurrentAfterTax)
                    reservation.AveragePricePerNightBeforeTax = (updated.TotalAmountProductCurrentBeforeTax / nights)
                    reservation.AveragePricePerNightAfterTax = (updated.TotalAmountProductCurrentAfterTax / nights)
                    break;
                case 'TotalAmountProductCurrentAfterTax':
                    reservation.TotalAmountProductCurrentBeforeTax = (updated.TotalAmountProductCurrentBeforeTax)
                    reservation.AveragePricePerNightBeforeTax = (updated.TotalAmountProductCurrentBeforeTax / nights)
                    reservation.AveragePricePerNightAfterTax = (updated.TotalAmountProductCurrentAfterTax / nights)
                    break;
                default:
                    break;
            }
            /*eslint-enable */
            setReservationState(reservation)
            setIsDirtyState(true)

        } catch (error) {
            error.status === 400 ? onWarning(error) : onError(error)
        }
        loader(false);
    }, 500), [])

    const save = () => {
        setErrors({})
        let shouldSave = true
        if (!reservationState.CheckInDate) {
            setErrors(prev => { return { ...prev, CheckIn: "Check In is a required field!" } })
            shouldSave = false
        }
        if (!reservationState.CheckOutDate) {
            setErrors(prev => { return { ...prev, CheckOut: "Check Out is a required field!" } })
            shouldSave = false
        }
        if (!reservationState.WingID) {
            setErrors(prev => { return { ...prev, WingID: "Wing is a required field!" } })
            shouldSave = false
        }
        if (!reservationState.RoomTypeId) {
            setErrors(prev => { return { ...prev, RoomTypeId: "Room Type is required field" } })
            shouldSave = false
        }
        if (!reservationState.ProductID) {
            setErrors(prev => { return { ...prev, ProductID: "Product is required field" } })
            shouldSave = false
        }
        if (!fits.length && (reservationState.Adults + reservationState.Children) <= 0) {
            setErrors(prev => { return { ...prev, Pax: "PAX is not valid" } })
            shouldSave = false
        }
        if (shouldSave && onSave) onSave(reservationState)
    }

    useEffect(() => {
        if (isDirtyState) {
            setReservationState(prev => {
                prev.RoomType = null
                return { ...prev }
            })
        }
    }, [reservationState.WingID, reservationState.CheckInDate, reservationState.CheckOutDate, reservationState.Quantity, reservationState.Adults, reservationState.Children, reservationState.Infants])

    const WingSpec = useMemo(() => { return { HotelID, IsActive: true } }, []);
    const RoomTypesSpec = React.useMemo(() => {
        return {
            HotelID,
            WingID: reservationState.WingID,
            BlockedRooms: reservationSavedState.initRoomsNumber,
            BlockedRoomTypeId: reservationSavedState.initRoomTypeId,
            FromDate: moment(reservationState.CheckInDate).startOf('day').toISOString(true),
            //Remove 1 day from checkoutDate because we dont want the availability to consider it
            ToDate: moment(reservationState.CheckOutDate).startOf('day').add(-1, 'days').toISOString(true),
            Quantity: reservationState.Quantity
        }
    }, [reservationState.WingID, reservationState.CheckInDate, reservationState.CheckOutDate, reservationState.Quantity])

    const ProductsSpec = React.useMemo(() => {
        return {
            HotelID,
            IncludeDayPricing: true,
            RoomTypeId: reservationState.RoomTypeId,
            StartDate: moment(reservationState.CheckInDate).startOf('day').toISOString(),
            EndDate: moment(reservationState.CheckOutDate).startOf('day').toISOString(),
            MaxAdults: 2,
            IsDayUse: moment(reservationState.CheckInDate).startOf('day').isSame(moment(reservationState.CheckOutDate).startOf('day')) ? true : false,
            AvoidAllRestriction: true,
            IsIncludeProductAndRate: true,
            IsNewAlgo: true,
            ProductMaximumAmountForReservation: true
        }
    }, [reservationState.RoomTypeId, reservationState.CheckInDate, reservationState.CheckOutDate, reservationState.WingID, reservationState.Quantity])

    useEffect(() => {
        if(!isDirtyState) return
        if (reservationState.RoomTypeId && reservationState.ProductID) {
            (async () => {
                let products = await GetProducts({
                    HotelID,
                    IncludeDayPricing: true,
                    RoomTypeId: reservationState.RoomTypeId,
                    StartDate: moment(reservationState.CheckInDate).startOf('day').toISOString(),
                    EndDate: moment(reservationState.CheckOutDate).startOf('day').toISOString(),
                    MaxAdults: 2,
                    ProductId: reservationState.ProductID,
                    IsDayUse: moment(reservationState.CheckInDate).startOf('day').isSame(moment(reservationState.CheckOutDate).startOf('day')) ? true : false,
                    AvoidAllRestriction: true,
                    IsIncludeProductAndRate: true,
                    IsNewAlgo: true,
                    ProductMaximumAmountForReservation: true
                })
                onSelectedProduct(_.first(products));
            })()
        }
        else {
            onSelectedProduct(null);
        }
    }, [reservationState.RoomTypeId, reservationState.CheckInDate, reservationState.CheckOutDate, reservationState.Quantity, reservationState.ProductID])



    const currencyFormat = currencyID => {
        return {
            format: '%v%s',
            symbol: Currencies[currencyID].symbol,
            locale: document.documentElement.lang || "he-IL"
        }
    }

    const productLabel = React.useCallback(item => {
        return formatCurrency(item.TotalAmountAfterTax, currencyFormat(item.CurrencyId))
    }, [])

    const calcAveragePricePerNightBeforeTax = () => {
        if (reservationState.AveragePricePerNightBeforeTax) {
            return reservationState.AveragePricePerNightBeforeTax
        } else if (reservationState.TotalAmountProductCurrentBeforeTax) {
            let nights = (moment(reservationState.CheckOutDate).startOf('day').diff(moment(reservationState.CheckInDate).startOf('day'), 'days'))
            if (!nights) nights = 1
            return reservationState.TotalAmountProductCurrentBeforeTax / nights
        }
        else return 0
    }

    const calcAveragePricePerNightAfterTax = () => {
        if (reservationState.AveragePricePerNightAfterTax) {
            return reservationState.AveragePricePerNightAfterTax
        }
        else if (reservation.TotalAmountProductCurrentAfterTax) {
            let nights = (moment(reservationState.CheckOutDate).startOf('day').diff(moment(reservationState.CheckInDate).startOf('day'), 'days'))
            if (!nights) nights = 1
            return reservationState.TotalAmountProductCurrentAfterTax / nights
        }
        else return 0
    }

    const reservationCurrencySymbol = useMemo(() => {
        let symbol = Currencies[reservationState.CurrencyId].symbol
        return symbol
    }, [reservationState.CurrencyId])

    useEffect(() => {
        isDirtyChange(isDirtyState)
    }, [isDirtyState])

    const onRoomTypeValueNotFound = () => {
        setReservationState(prev => {
            prev.RoomType = null
            prev.RoomTypeId = null
            return { ...prev }
        })
    }

    const language = useContext(LanguageContext)

    const text = key => {
        return language ? language.texts[key] : key
    }
    return (
        <Panel header={
            <div>
                <Dimmer active={fits && fits.length > 0} inverted style={{ opacity: 0.5 }} />
                <div className="header" style={{ display: "inline-block" }}>{text('BlockDetails')} - {text('Reservation')} : {reservationState.Number ||text('NewBlock')}</div>
                <Button primary disabled={!isDirtyState} floated="right" onClick={save}>{text('Save')}</Button>
                <Button negative disabled={!isDirtyState} floated="right" onClick={onCancel}>{text('Cancel')}</Button>
            </div>
        }>
            <Dimmer active={fits && fits.length > 0} inverted style={{ opacity: 0.5 }} />
            <Form size="small">
                <Form.Group widths="equal">
                    <DatePicker
                        clearable={false}
                        label={text('CheckIn')}
                        onChange={(value) => { onBlockDateFieldChange(value, "CheckInDate") }}
                        value={reservationState.CheckInDate ? moment(reservationState.CheckInDate).startOf('day').toDate() : null}
                        minDate={moment(state.Hotel.HotelParameter.CurrentBusinessDate).startOf('day').toDate()}
                        error={errors.CheckIn}
                    />
                    <DatePicker
                        clearable={false}
                        label={text('CheckOut')}
                        onChange={(val) => { onBlockDateFieldChange(val, 'CheckOutDate') }}
                        name="CheckOutDate"
                        value={reservationState.CheckOutDate ? moment(reservationState.CheckOutDate).startOf('day').toDate() : moment(reservationState.CheckInDate).add(1, 'days').toDate()}
                        minDate={moment(reservationState.CheckInDate).startOf('day').toDate()}
                        error={errors.CheckOut}
                    />
                </Form.Group>
                <Form.Group widths="4">
                    <Form.Field
                        value={String(reservationState.Adults)}
                        onChange={(value) => { onBlockFieldChange(value, "Adults") }}
                        control={NumericInput}
                        label={text('Adult')}
                        placeholder=''
                        buttonPlacement="right"
                        digits={0}
                        min={0}
                        max={1000}
                        error={errors.Pax}
                    >
                    </Form.Field>
                    <Form.Field
                        value={String(reservationState.Children)}
                        control={NumericInput}
                        name='Child'
                        onChange={(value) => { onBlockFieldChange(value, "Children") }}
                        label={text('Child')}
                        placeholder=''
                        buttonPlacement="right"
                        digits={0}
                        min={0}
                        max={1000}
                        error={errors.Pax}
                    >
                    </Form.Field>
                    <Form.Field
                        value={String(reservationState.Infants)}
                        control={NumericInput}
                        name='Infant'
                        onChange={(value) => { onBlockFieldChange(value, "Infants") }}
                        label={text('Infant')}
                        placeholder=''
                        buttonPlacement="right"
                        min={0}
                        max={1000}
                        digits={0}
                        error={errors.Pax}
                    />
                    <Form.Field
                        value={String(reservationState.Quantity)}
                        onChange={(value) => { onBlockFieldChange(value, "Quantity") }}
                        min={1}
                        max={1000}
                        control={NumericInput}
                        label={text('Rooms')}
                        placeholder=''
                        digits={0}
                        buttonPlacement="right">
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Field
                        control={TimePicker}
                        value={reservationState.Eta}
                        onChange={(value) => { onBlockFieldChange(value, "Eta") }}
                        type="basic"
                        label={text("ETA")}
                        key="ETA">
                    </Form.Field>
                    <Form.Field
                        control={TimePicker}
                        value={reservationState.Edt}
                        onChange={(value) => { onBlockFieldChange(value, "Edt") }}
                        type="basic"
                        label={text("ETD")}
                        key="ETD">
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Field required
                        label={text("Wing")}
                        name="WingID"
                        control={WingDropDown}
                        spec={WingSpec}
                        onChange={(value) => { onBlockFieldChange(value, "WingID") }}
                        value={reservationState.WingID}
                        error={errors.WingID}
                        selectFirst={true}
                    >
                    </Form.Field>
                    <Form.Field required
                        label={text("RoomType")}
                        name="RoomTypeId"
                        control={RoomTypesDropDown}
                        spec={RoomTypesSpec}
                        initial={reservationState.RoomType}
                        onChange={(value) => { onBlockFieldChange(value, "RoomTypeId") }}
                        value={reservationState.RoomTypeId}
                        error={errors.RoomTypeId}
                        onValueNotFound={onRoomTypeValueNotFound}
                        noResultsMessage={<span style={{ color: 'red' }}>No availability was found</span>}
                        search={true}
                    >
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Input
                        label={text("Status")}
                        name="ReservationStatus"
                        value={text(ReservationStatusTypes[reservationState.StatusId.toString()])}
                        readOnly
                    >
                    </Form.Input>
                    <Form.Field required>
                        <label>{text('Product')}</label>
                        <ProductsDropDown
                            name="ProductID"
                            descriptionField="RateName"
                            labelField={productLabel}
                            spec={ProductsSpec}
                            data={!reservationState.RoomTypeId ? [] : null}
                            onChange={(value) => { onBlockFieldChange(value, "ProductID") }}
                            value={reservationState.ProductID}
                            error={errors.ProductID}
                        />
                        <div className="error">{"* " + text('DoublePrice')}</div>
                    </Form.Field>
                </Form.Group>
                <Form.Field
                    name='Nights'
                    label={text('Nights') + ': ' + moment(reservationState.CheckOutDate).startOf('day').diff(moment(reservationState.CheckInDate).startOf('day'), 'days')}
                />
                <Form.Group widths="equal">
                    <Form.Field>
                        <label>{text('AverageBlockPricePerNight') +" (" + text('NotIncTax') +")"}</label>
                        <CurrencyInput
                            size="small"
                            currency={reservationCurrencySymbol}
                            placeholder=""
                            value={calcAveragePricePerNightBeforeTax()}
                            onChange={(value) => { onPriceFieldsChange(value, "AveragePricePerNightBeforeTax") }}
                            readOnly={!reservationState.ProductID}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>{text('TotalBlockPrice')+" (" + text('NotIncTax') +")"}</label>
                        <CurrencyInput
                            size="small"
                            currency={reservationCurrencySymbol}
                            placeholder=""
                            value={reservationState.TotalAmountProductCurrentBeforeTax || 0}
                            onChange={(value) => { onPriceFieldsChange(value, "TotalAmountProductCurrentBeforeTax") }}
                            readOnly={!reservationState.ProductID}
                        />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Field>
                        <label>{text('AverageBlockPricePerNight') +" (" + text('IncTaxBlock') +")"}</label>
                        <CurrencyInput
                            size="small"
                            currency={reservationCurrencySymbol}
                            placeholder=""
                            value={calcAveragePricePerNightAfterTax()}
                            onChange={(value) => { onPriceFieldsChange(value, "AveragePricePerNightAfterTax") }}
                            readOnly={!reservationState.ProductID}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>{text('TotalBlockPrice')+" (" + text('IncTaxBlock') +")"}</label>
                        <CurrencyInput
                            size="small"
                            currency={reservationCurrencySymbol}
                            placeholder=""
                            value={reservationState.TotalAmountProductCurrentAfterTax || 0}
                            onChange={(value) => { onPriceFieldsChange(value, "TotalAmountProductCurrentAfterTax") }}
                        />
                    </Form.Field>
                </Form.Group>
            </Form>
        </Panel>
    )
}
BlockDetailsPanel.propTypes = {
    reservation: PropTypes.object,
    reservationSavedState: PropTypes.object,
    HotelID: PropTypes.any,
    onBlockFieldChange: PropTypes.func,
    onSave: PropTypes.func,
    onSelectedProduct: PropTypes.func,
    onPriceFieldsChange: PropTypes.func,
    onBlockDateFieldChange: PropTypes.func,
    isDirty: PropTypes.bool,
    resetRoomType: PropTypes.func,
    onCancel: PropTypes.func,
    isDirtyChange: PropTypes.func
}
export default BlockDetailsPanel